import { useEffect, useState } from "react";
import { Route, useLocation, Routes } from "react-router-dom";

import PaintingGallery from "./components/gallery/PaintingGallery";

import Contact from "./components/contact/Contact";
import LaUne from "./components/laune/LaUne";
import Expos from "./components/expos/Expos";
import { Painting } from "./components/gallery/painting";
import Menu from "./components/menu/Menu";
import { Environment } from "./environments/environment";

function App() {
  useEffect(() => {
    //logPageView(window.location.pathname);
  });

  return (
    <div id="darkbg">
      <Menu />
      <RoutesWrapper />
    </div>
  );
}

function RoutesWrapper() {
  let location = useLocation();
  const [paintings, setPaintings] = useState<Painting[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const baseUrl = Environment.getBaseUrl();
  const paintingsJsonUrl = `${baseUrl}/config/paintings.json`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(paintingsJsonUrl);
        if (!response.ok) {
          throw new Error(`Erreur HTTP! statut: ${response.status}`);
        }
        const jsonData: Painting[] = await response.json();
        setPaintings(jsonData);
      } catch (e) {
        console.error("Erreur lors du chargement de paintings.json:", e);
        setError(
          "Erreur lors du chargement des données des tableaux. Veuillez réessayer plus tard."
        );
        setPaintings(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [paintingsJsonUrl]);

  useEffect(() => {
    //logPageView(location.pathname); // Vous pouvez réactiver le tracking GA4 ici si besoin
  }, [location]);

  if (loading) {
    return <p>Chargement des données des tableaux...</p>; // Message de chargement
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>; // Message d'erreur en rouge
  }

  // Si paintingsData est chargé, on rend les routes avec PaintingGallery
  if (paintings) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <LaUne
              paintings={paintings.filter(
                (painting) =>
                  painting.homePage === true && painting.orientation === "C"
              )} // Filtrage pour 'home'
            />
          }
        />
        <Route
          path="/index.html"
          element={
            <LaUne
              paintings={paintings.filter(
                (painting) =>
                  painting.homePage === true && painting.orientation === "C"
              )} // Filtrage pour 'home'
            />
          }
        />
        <Route path="/expos" element={<Expos />} />
        <Route
          path="/tableaux-l"
          element={
            <PaintingGallery
              paintings={paintings.filter(
                (painting) => painting.orientation === "L"
              )} // Filtrage pour 'landscape'
            />
          }
        />
        <Route
          path="/tableaux-c"
          element={
            <PaintingGallery
              paintings={paintings.filter(
                (painting) => painting.orientation === "C"
              )} // Filtrage pour 'carrés'
            />
          }
        />
        <Route
          path="/tableaux-h"
          element={
            <PaintingGallery
              paintings={paintings.filter(
                (painting) => painting.orientation === "P"
              )} // Filtrage pour 'portrait'
            />
          }
        />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    );
  }

  return null;
}

export default App;
